<template>
  <div>
    <div class='table' v-if="!loadingData">
      <template>
        <div
          class="table__item table__item-header background bottom-line without-line2 text-center right-line">
          Уровень программ
        </div>
        <div class="table__item table__item-header background right-line bottom-line without-line3 text-center">
          Форма
        </div>
        <div class="table__item table__item-header background right-line bottom-line without-line4 text-center">
          Численность обучающихся (без учета иностранных граждан и лиц без гражданства, в том числе соотечественников,
          проживающих за рубежом, обучающихся в соответствии с установленной Правительством Российской Федерации квотой
          на образование иностранных граждан и лиц без гражданства в Российской Федерации), человек
        </div>
        <div
          class="table__item table__item-header background bottom-line without-line5 text-center">
          Численность обучающихся – иностранных граждан, человек
        </div>

        <div class="table__item table__item-header right-line bottom-line text-center xxx1">
          без учета обучающихся в соответствии с установленной Правительством Российской Федерации квотой на образование
          иностранных граждан и лиц без гражданства в Российской Федерации
        </div>
        <div class="table__item table__item-header bottom-line text-center xxx2">
          обучающихся в соответствии с установленной Правительством Российской Федерации квотой на образование
          иностранных граждан и лиц без гражданства в Российской Федерации
        </div>

        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear-2}}</div>
        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear-1}}</div>
        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear}}</div>
        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear-2}}</div>
        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear-1}}</div>
        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear}}</div>
        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear-2}}</div>
        <div class="table__item table__item-header right-line bottom-line text-center">на 01.01.{{baseYear-1}}</div>
        <div class="table__item table__item-header bottom-line text-center">на 01.01.{{baseYear}}</div>

        <div class="table__item pa-0 table__item-header bottom-line text-center">1</div>
        <div class="table__item pa-0 table__item-header left-line right-line bottom-line text-center">2</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">3</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">4</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">5</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">6</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">7</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">8</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">9</div>
        <div class="table__item pa-0 table__item-header right-line bottom-line text-center">10</div>
        <div class="table__item pa-0 table__item-header bottom-line text-center">11</div>

        <div class="table__item bottom-line">Ординатура</div>
        <div class="table__item left-line right-line bottom-line text-center"> все формы обучения</div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
          v-for="item in dataFields.slice(0,3)" :key="item.name">
          <fives-table-cell
            v-bind="calcPropsForCell(item.name)"
            :disabled="organizationBlocked"
            style="flex: 1 0"
            @open-dialog="openDialog($event, item.name)"/>
          <v-btn small icon @click="openTooltip(item.name)">
            <v-icon
              :size="15"
              class="grey-light-color__important "
            >
              mdi-information
            </v-icon>
          </v-btn>
        </div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'>x
        </div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'>x
        </div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
          v-for="item in dataFields.slice(5,9)" :key="item.name">
          <fives-table-cell
            v-bind="calcPropsForCell(item.name)"
            :disabled="organizationBlocked"
            style="flex: 1 0"
            @open-dialog="openDialog($event, item.name)"/>
          <v-btn small icon @click="openTooltip(item.name)">
            <v-icon
              :size="15"
              class="grey-light-color__important "
            >
              mdi-information
            </v-icon>
          </v-btn>
        </div>
        <div class="table__item bottom-line">Ассистентура-стажировка</div>
        <div class="table__item left-line right-line bottom-line text-center">все формы обучения</div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
          v-for="item in dataFields.slice(9,12)" :key="item.name">
          <fives-table-cell
            v-bind="calcPropsForCell(item.name)"
            :disabled="organizationBlocked"
            style="flex: 1 0"
            @open-dialog="openDialog($event, item.name)"/>
          <v-btn small icon @click="openTooltip(item.name)">
            <v-icon
              :size="15"
              class="grey-light-color__important "
            >
              mdi-information
            </v-icon>
          </v-btn>
        </div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'>x
        </div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'>x
        </div>
        <div
          class='table__item bottom-line right-line item-data text-center d-flex flex-row align-center justify-space-around'
          v-for="item in dataFields.slice(14,18)" :key="item.name">
          <fives-table-cell
            v-bind="calcPropsForCell(item.name)"
            :disabled="organizationBlocked"
            style="flex: 1 0"
            @open-dialog="openDialog($event, item.name)"/>
          <v-btn small icon @click="openTooltip(item.name)">
            <v-icon
              :size="15"
              class="grey-light-color__important "
            >
              mdi-information
            </v-icon>
          </v-btn>
        </div>
        <div class="table__item">Аспирантура</div>
        <div class="table__item left-line right-line text-center">все формы обучения</div>
        <div class='table__item right-line item-data text-center d-flex flex-row align-center justify-space-around'
             v-for="item in dataFields.slice(18,27)" :key="item.name">
          <fives-table-cell
            v-bind="calcPropsForCell(item.name)"
            :disabled="organizationBlocked"
            style="flex: 1 0"
            @open-dialog="openDialog($event, item.name)"/>
          <v-btn small icon @click="openTooltip(item.name)">
            <v-icon
              :size="15"
              class="grey-light-color__important "
            >
              mdi-information
            </v-icon>
          </v-btn>
        </div>
      </template>
    </div>
    <div v-else-if="loadingData" class="d-flex flex-row align-center justify-center" style="min-width: 150px;">
      <v-progress-linear indeterminate/>
    </div>
    <appeal-dialog
      ref="appeal-dialog"
      :appeal-id="appealId"
      :file-id="fileId"
      :appeal="appealCell"
      :value="appealValue"
      :appeal-info="appealInfo"
      @saved-value="saveValue($event)"
      @closing-dialog="closingAppealDialog"
    ></appeal-dialog>
    <tooltip-forms5-dialog
      ref="tooltip-dialog"
      :data-field="dataFieldTooltip"
    >
    </tooltip-forms5-dialog>
  </div>
</template>

<script>
import FivesTableCell from "@/components/fields/fivesTableCell";
import appealDialog from "@/components/Dialogs/appealForms5_1-4Dialog";
import tooltipForms5Dialog from "@/components/Dialogs/tooltipForms5Dialog";
import Form5Controller from "@/controllers/Organizations/Form5Controller";
import {setAppealFromOneToFourDialog} from "@/mixins/forms5/appealDialogF1-4";
import {headerTooltipFunctions} from "@/mixins/forms5/headerTooltip";
import {fiveFormsMixin} from "@/mixins/formUsl";
import {mapActions, mapGetters} from "vuex";

export default {
  name: "form5_4",
  mixins: [setAppealFromOneToFourDialog, headerTooltipFunctions, fiveFormsMixin],
  components: {FivesTableCell, appealDialog, tooltipForms5Dialog},
  props: {
    baseYear: {
      type: Number,
      required: true
    },
    chosenChildOrg: {
      type: Object,
      required: true,
      default: () => {
        return {}
      }
    },
  },
  data() {
    return {
      serverData: [],
      loadingData: false,
      loadingMenu: {value: false, id: ''},
      dataFields: [
        {name: "noors20K22"},
        {name: "noors21K22"},
        {name: "noors22K22"},
        {name: "nfors20Nk1"},
        {name: "nfors21Nk1"},
        {name: "nfors22Nk1"},
        {name: "nqors20Nk1"},
        {name: "nqors21Nk1"},
        {name: "nqors22Nk1"},

        {name: "noass20K22"},
        {name: "noass21K22"},
        {name: "noass22K22"},
        {name: "nfass20Nk1"},
        {name: "nfass21Nk1"},
        {name: "nfass22Nk1"},
        {name: "nqass20Nk1"},
        {name: "nqass21Nk1"},
        {name: "nqass22Nk1"},

        {name: "noaps20Nk1"},
        {name: "noaps21Nk1"},
        {name: "noaps22Nk1"},
        {name: "nfaps20Nk1"},
        {name: "nfaps21Nk1"},
        {name: "nfaps22Nk1"},
        {name: "nqaps20Nk1"},
        {name: "nqaps21Nk1"},
        {name: "nqaps22Nk1"},
      ]
    }
  },
  created() {
    if (this.get_spr_data_usl_loading === false)
      this.loadingDataTable();
  },
  watch: {
    getChosenOrgId() {
      this.loadingDataTable();
    }
  },
  computed: {
    ...mapGetters('spr', {getChosenOrgId: 'getChosenOrgId'}),
  },
  methods: {
    ...mapActions('notifications', {addNotification: 'addNotification'}),
    async loadingDataTable() {
      this.loadingData = true;
      try {
        this.serverData = await Form5Controller.getForm('part4', false, false, this.chosenChildOrg?.id);
        this.loadingData = false;
      } catch (e) {
        await this.addNotification({
          notificationStatus: 'error',
          notificationMessage: 'Нет данных',
          timeout: 5000
        })
        this.loadingData = false;
      }
    },
    calcPropsForCell(dataField) {
      return {
        value: this.serverData[dataField],
        title: '',
        cell: {dataField: dataField},
        id: this.serverData.id,
        row: this.serverData,
        loading: this.loading,
      }
    },
    saveValue(e) {
      this.serverData[e.dataField] = {
        oldValue: e.oldValue,
        newValue: e.newValue,
        id: e.id,
        accept: e.accept
      };
      this.$refs["appeal-dialog"].closeDialog();
    }
  },
}
</script>

<style lang="scss" scoped>
.table {
  display: grid;
  grid-template-columns: 1fr 1fr repeat(9, minmax(100px, 150px));
  color: #89A0B0;
  background-color: #FFFFFF;
  border-radius: 6px;
  box-shadow: 0 6px 18px rgb(0 0 0 / 6%);
  margin-bottom: 20px;
  padding: 12px;
  margin-right: auto;
  margin-left: auto;
  overflow: auto;

  &::-webkit-scrollbar {
    height: 8px;
  }
}

.table__item-header {
  font-size: 12px;
}

.table__item {
  padding: 5px;
  font-size: 14px;
  border: 1px solid #CFD8DC;

  &:not(.table__item-header) {
    color: #455A64
  }
}

.top-line {
  border-top: none;
}

.left-line {
  border-left: none;
}

.bottom-line {
  border-bottom: none;
}

.right-line {
  border-right: none;
}

.without-line {
  grid-column-start: 1;
  grid-column-end: 12;
}

.without-line2 {
  grid-column-start: 1;
  grid-column-end: 2;
  grid-row-start: 1;
  grid-row-end: 5;
}

.without-line3 {
  grid-column-start: 2;
  grid-column-end: 3;
  grid-row-start: 1;
  grid-row-end: 5;
}

.without-line4 {
  grid-column-start: 3;
  grid-column-end: 6;
  grid-row-start: 1;
  grid-row-end: 4;
}

.without-line5 {
  grid-column-start: 6;
  grid-column-end: 12;
  grid-row-start: 1;
  grid-row-end: 2;
}

.xxx1 {
  grid-column-start: 6;
  grid-column-end: 9;
  grid-row-start: 2;
  grid-row-end: 4;
}

.xxx2 {
  grid-column-start: 9;
  grid-column-end: 12;
  grid-row-start: 2;
  grid-row-end: 4;
}

.item-data:hover {
  background: rgba(207, 224, 236, 0.42);
}
</style>